/*
 * MIST Originals picker (snippets/mist-ratio-picker.liquid).
 * - Keeps strength un-chosen after a bare page load until the shopper taps one (product-info[data-mist-pending]).
 *   Dawn re-renders the picker on each option change, so the state lives on the product-info element.
 * - While pending, both add buttons read "Choose a strength" and submitting nudges the strength row.
 * - Variants with no photo of their own: lead the gallery with the same-blend photo the server picked.
 */
(() => {
  const PENDING = 'data-mist-pending';
  const LABEL = 'Choose a strength';

  const pickerOf = (info) => info.querySelector('[data-mist-picker]');
  const isPending = (info) => info.hasAttribute(PENDING) && !info.mistChosen;

  function buttons(info) {
    return [
      info.querySelector('.product-form__submit > span'),
      info.querySelector('.product__sticky-bar button'),
    ].filter(Boolean);
  }

  function apply(info) {
    if (!pickerOf(info)) return;
    if (!isPending(info)) {
      info.removeAttribute(PENDING);
      buttons(info).forEach((el) => {
        if (el.dataset.mistOrig !== undefined) {
          el.innerHTML = el.dataset.mistOrig;
          delete el.dataset.mistOrig;
        }
      });
      return;
    }
    info.querySelectorAll('[data-mist-strength] input:checked').forEach((input) => (input.checked = false));
    buttons(info).forEach((el) => {
      if (el.dataset.mistOrig === undefined) el.dataset.mistOrig = el.innerHTML;
      el.textContent = LABEL;
    });
  }

  function nudge(info) {
    const row = info.querySelector('[data-mist-strength] .mist-mgs');
    const need = info.querySelector('[data-mist-need]');
    need?.classList.add('is-shown');
    if (row) {
      row.classList.remove('is-nudged');
      void row.offsetWidth;
      row.classList.add('is-nudged');
      row.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      row.querySelector('input:not(.disabled)')?.focus({ preventScroll: true });
    }
  }

  // Before Dawn reads the checked inputs (bubbling 'change' on <variant-selects>):
  // a strength tap ends the pending state; a kit change while pending sends the hidden strength
  // along so Shopify keeps a sensible match, then apply() clears it again after the re-render.
  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      const info = input.closest?.('product-info');
      if (!info || !input.closest('[data-mist-picker]')) return;
      if (!isPending(info)) {
        // Kit change after a strength was chosen: remember it, so a strength the new kit lacks asks again.
        if (input.closest('[data-mist-ratio]')) {
          info.mistPrevStrength = info.querySelector('[data-mist-strength] input:checked')?.value || null;
        }
        return;
      }
      if (input.closest('[data-mist-strength]')) {
        info.mistChosen = true;
        return;
      }
      const id = pickerOf(info).dataset.mistStrengthId;
      const hidden = id && info.querySelector(`[data-mist-strength] input[data-option-value-id="${id}"]`);
      if (hidden) hidden.checked = true;
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      // form.id would be its <input name="id">, so read the attribute.
      if (!form.getAttribute?.('id')?.startsWith('product-form-')) return;
      const info = form.closest('product-info');
      if (!info || !isPending(info)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      nudge(info);
    },
    true
  );

  function init() {
    document.querySelectorAll('product-info').forEach(apply);
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const info = document.querySelector(`product-info[data-section="${data.sectionId}"]`);
      if (!info || !pickerOf(info)) return;
      const mediaId = data.html.querySelector('[data-mist-picker]')?.dataset.mistDisplayMedia;
      if (!data.variant?.featured_media && mediaId && typeof info.updateMedia === 'function') {
        info.updateMedia(data.html, mediaId);
      }
      if (info.mistPrevStrength) {
        // Read the response: Dawn keeps the old (hidden) picker in the DOM for 500ms after the swap.
        const now = data.html.querySelector('[data-mist-strength] input:checked')?.value;
        if (now !== info.mistPrevStrength) {
          info.mistChosen = false;
          info.setAttribute(PENDING, '');
        }
        info.mistPrevStrength = null;
      }
      // Run after the sticky bar and Dawn have finished swapping their markup.
      setTimeout(() => apply(info), 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
